import React from 'react';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import 'echarts-wordcloud';
import { useLocation,useSearchParams,useNavigate} from 'react-router-dom';
import {Layers} from 'react-feather';
import {SGERI_ORG_SYNONYM} from '@constants';
import util from "@utils/utils";
import { useConfig } from '../../../../contexts/ConfigContext';
// import useGetOrgAndNum from '../../hooks/useGetOrgAndNum';
export const HomeStatsA = (props) => {
    const {orgAndNumData,setSearchOrg} = props
    const { theme } = useConfig();
    // const {orgAndNumLoading,orgAndNumData} = useGetOrgAndNum()
    const option = {
        series: [
          {
            type: 'wordCloud',
            gridSize: 2,
            sizeRange: [12, 50],
            rotationRange: [-90, 90],
            shape: 'pentagon',
            textStyle: {
              normal: {
                color: function() {
                  return (
                    'rgb(' +
                    [
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255),
                    ].join(',') +
                    ')'
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            data: [
              {
                name: '电力',
                value: 10000,
              },
              {
                name: '能源',
                value: 6181,
              },
              {
                name: '氢能源',
                value: 4386,
              },
              {
                name: '新质生产力',
                value: 4055,
              },
              {
                name: '新能源汽车',
                value: 2467,
              },
              {
                name: '环境保护',
                value: 2244,
              },
              {
                name: '北京',
                value: 1898,
              },
              {
                name: '越南',
                value: 1484,
              },
              {
                name: '印度',
                value: 1112,
              },
              {
                name: '新规',
                value: 965,
              },
              {
                name: '人工智能',
                value: 847,
              },
              {
                name: '大模型',
                value: 582,
              },
              {
                name: '大语言模型',
                value: 555,
              },
              {
                name: '管理',
                value: 550,
              },
              {
                name: '长江',
                value: 462,
              },
              {
                name: '电价',
                value: 366,
              },
              {
                name: 'LLM',
                value: 360,
              },
              {
                name: '安全',
                value: 282,
              },
              {
                name: '稳定',
                value: 273,
              },
              {
                name: '开放',
                value: 273,
              },
              {
                name: '改革',
                value: 265,
              },
            ],
          },
        ],
      };
    // 点击事件处理函数
  // const onWordCloudClick = (params) => {
  //     searchAction(params.name)
  //     console.log('Clicked word:', params.name);
  // };
  const navigate = useNavigate();

  const OrgOptions = [
    {
      name:'国务院',
      // ico:'https://policy.ckcest.cn/img/main/nav5-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('国务院',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '国务院')[0]?.num
    },
    {
      name:'发改委',
      // ico:'https://policy.ckcest.cn/img/main/nav5-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('发改委',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '发改委')[0]?.num
    },
    {
      name:'国资委',
      // ico:'https://policy.ckcest.cn/img/main/nav5-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('国资委',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '国资委')[0]?.num
    },
    {
      name:'能源局',

      // ico:'https://policy.ckcest.cn/img/main/nav2-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('能源局',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '能源局')[0]?.num
    },
    {
      name:'工信部',
      // ico:'https://policy.ckcest.cn/img/main/nav11-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('工信部',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '工业和信息化部')[0]?.num
    },
    {
      name:'财政部',
      // ico:'https://policy.ckcest.cn/img/main/nav15-hover.png',
      // ico:require('@/images/orgIcons/fgw.png'),
      ico:<Layers/>,
      num:util.summateOrgNum('财政部',orgAndNumData)
      // num:orgAndNumData?.filter(item=>item?.org_name === '生态环境部')[0]?.num
    },
    // {
    //   name:'国资委',
    //   ico:'https://policy.ckcest.cn/img/main/nav15-hover.png',
    //   num:orgAndNumData?.filter(item=>item?.org_name === '国资委')[0]?.num
    // },
    // {
    //   name:'科技部',
    //   // ico:'https://policy.ckcest.cn/img/main/nav4-hover.png',
    //   ico:require('@/images/orgIcons/kjb.png'),
    //   num:orgAndNumData?.filter(item=>item?.org_name === '科技部')[0]?.num
    // },
    // {
    //   name:'司法部',
    //   // ico:'https://policy.ckcest.cn/img/main/nav16-hover.png',
    //   ico:require('@/images/orgIcons/sfb.png'),
    //   num:orgAndNumData?.filter(item=>item?.org_name === '司法部')[0]?.num
    // },
  ]

  const allSubjectOptions = [
    {
      name:'重要讲话',
      description:'习总书记讲话报告',
      // bg:'https://img1.baidu.com/it/u=4267434241,3835685484&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=450'
      bg:require('@images/subjects/subject1.jpg'),
    },
    {
      name:'新型电力系统',
      description:'能源电力领域前沿政策',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3uEyttOaQWGiPikUeriHXn.png'
      bg:require('@images/subjects/subject2.png'),
    },
    {
      name:'双碳',
      description:'碳达标、碳中和政策动态',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/0yN5LnLdWUkgWUZ4Lyn3fm.png'
      bg:require('@images/subjects/subject4.png'),
    },
    {
      name:'能源前沿科技',
      description:'大模型等前沿科技进展',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3pBo0tQJhBN2Wu0nHslYm8.png'
      bg:require('@images/subjects/subject3.png'),
    },
    {
      name:'国际贸易',
      description:'国际贸易政策动态',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/0yN5LnLdWUkgWUZ4Lyn3fm.png'
      bg:require('@images/subjects/subject5.png'),
    },
    {
      name:'大湾区',
      description:'大湾区相关政策',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3pBo0tQJhBN2Wu0nHslYm8.png'
      bg:require('@images/subjects/subject6.png'),
    },
  ]

  // a环境只显示前4个专题
  const subjectOptions = allSubjectOptions.slice(0, 4)

    return (
       <div className='md:w-[37%] bg-base-200 h-full py-4 pl-3 flex flex-col gap-6'>
            {/* <div className="card bg-base-100 w-full ">
                <div className="card-body">
                    <h2 className="card-title text-primary">热门关键词</h2>
                </div>
                <div className='' style={{height:220}}>
                    <ReactEcharts
                        option={option}
                        notMerge
                        lazyUpdate
                        style={{ height: '100%', width: '100%' }}
                        onChartReady={(chart) => {
                            // 绑定点击事件
                            chart.on('click', (params) => {
                              if (params.seriesType === 'wordCloud') {
                                onWordCloudClick(params);
                              }
                            });
                          }}
                    />
                </div>
            </div> */}

            <div className="card bg-base-100 w-full shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-primary">政策来源</h2>
                    <div class="grid grid-cols-2  3xl:grid-cols-3 gap-4 mt-4">
                      {
                        OrgOptions?.map(item=>
                          <div class="card shadow-xl" style={{ backgroundColor: theme.primary }}>
                              <div className="card image-full w-full shadow-xl hover:scale-105 transition-all duration-300" style={{ backgroundColor: theme.primary }}>
                                  <div className="card-body cursor-pointer" onClick={()=>{
                                    const stateGridRelated = 'true';
                                    navigate(`/policy/search?k=&org=${encodeURIComponent(item?.name)}&state_grid_related=${stateGridRelated}`);
                                  }}>
                                    {/* <img className="w-12 h-12 mb-2 m-auto" src={item?.ico}/> */}
                                    <div className="h-6 mb-2 m-auto">{item?.ico}</div>
                                    <h2 className="card-title justify-center">
                                      <div>
                                        <div className='whitespace-nowrap text-white' >{item?.name}</div>
                                        {
                                        item?.num !== undefined && item?.num !== null ?
                                        <div className="text-lg text-center">({item?.num})</div> : <span className="skeleton h-6 w-16"></span>
                                        }
                                      </div>
                                    </h2>
                                  </div>
                              </div>
                          </div>
                        )
                      }
                    </div>
                    {/* <div className='flex justify-end mt-1'>
                      <button className='btn btn-link'
                        onClick={()=>navigate(`/policy/search?k=&org=`)}
                      >
                        查看更多 {'>>'}
                      </button>
                    </div> */}
                </div>

            </div>


                       <div className="card bg-base-100 w-full shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-primary">政策专题</h2>
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                      {
                        subjectOptions?.map(item=>(
                        <div class="card bg-base-100 shadow-xl">
                          <div className="card bg-base-100 image-full w-full shadow-xl">
                            <figure>
                                <img
                                src={item.bg}
                                alt="" />
                            </figure>
                            <div className="card-body">
                                <h2 className="card-title">{item?.name}</h2>
                                <p>{item?.description}</p>
                                <div className="card-actions justify-end">
                                <button className="btn"
                                onClick={()=>{
                                  navigate(`/policy/subject?name=${encodeURIComponent(item?.name)}`)
                                }}
                                >进入专题</button>
                                </div>
                            </div>
                          </div>
                        </div>
                        ))
                      }
                    </div>
                </div>


            </div>
        </div>

    )
}